import { render, staticRenderFns } from "./viewCompliance.vue?vue&type=template&id=2054a160&"
import script from "./viewCompliance.vue?vue&type=script&lang=js&"
export * from "./viewCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports